// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3oMH-","right":"styles_right__p8Mu_"};